<template>
  <div class="business-home-page">
    <PresentationBlock>
      <div class="biz-hero-container__row">
        <div class="biz-hero-container__inner--left">
          <span class="biz-hero-container__eyebrow">m2VET dla biznesu</span>
          <h2>Zacznij razem z nami</h2>
          <p>
            Prowadzisz gabinet weterynaryjny albo salon groomerski? Załóż konto usługodawcy w naszym serwisie.
            m2VET dla biznesu to narzędzie, które pozwoli Ci stworzyć własną wizytówkę.
            Ponadto za pośrednictwem serwisu będziesz mógł/mogła prowadzić kalendarz, przez który Twoi klienci będą mogli umawiać się na wizyty.
          </p>

          <img
              src="@/assets/illustrations/business/offer-item.svg"
              class="biz-hero-container__inner--left__hero-mobile"
              alt=""
          >

          <div class="biz-hero-container__inner--left__scroll-down">
            <span>Zobacz naszą ofertę</span>
            <img src="@/assets/icons/arrow-down-short.svg" alt="">
          </div>
        </div>

        <div class="biz-hero-container__inner--right">
          <img src="@/assets/illustrations/business/offer-item.svg" alt="">
        </div>
      </div>
    </PresentationBlock>

    <PresentationBlock>
      <div class="section__head section__head--center">
        <h2>Co oferujemy?</h2>
        <p>Kompleksowe wsparcie dla gabinetów, klinik i specjalistów.</p>
      </div>

      <OfferVue />
    </PresentationBlock>

    <PresentationBlock>
      <div class="container">
        <div class="section__head section__head--center">
          <h2>Skontaktuj się z nami</h2>
          <p>W razie jakichkolwiek pytań, jesteśmy do Twojej dyspozycji.</p>
        </div>

        <div class="contact-form__content">
          <div class="contact-form__illustration">
            <img src="@/assets/illustrations/business/contact-support.svg" alt="Ilustracja kontaktu">
          </div>

          <div class="contact-form__card">
            <ContactFormVue />
          </div>
        </div>
      </div>
    </PresentationBlock>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import OfferVue from '@/components/HomeComponents/biz/Offer.vue';
import ContactFormVue from '@/components/HomeComponents/biz/ContactForm.vue';
import axios from 'axios';
import PresentationBlock from "@/components/HomeComponents/biz/Partials/PresentationBlock.vue";

export default {
  name: 'BusinessHomePage',
  setup() {
    useMeta({
      title: 'Dla biznesu',
      meta: [{ name: 'robots', Name: 'robots', content: 'all' }]
    });
  },
  data() {
    return {
      reviews: null
    };
  },
  components: {
    PresentationBlock,
    OfferVue,
    ContactFormVue
  },
  mounted() {
    this.getReviews();
  },
  methods: {
    getReviews() {
      axios.get('/CmsAll').then(res => {
        this.reviews = res.data.filter(item => item.title.includes('Opinia'));
      }).catch(() => {});
    }
  }
};
</script>

<style lang="scss">
.biz-hero-container {
  width: min(1200px, calc(100% - 32px));
  margin: 28px auto 0;
  padding: 28px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
  display: grid;
  grid-template-columns: 1.05fr .95fr;
  gap: 24px;
  align-items: center;

  &__eyebrow {
    display: inline-flex;
    align-self: flex-start;
    padding: 6px 10px;
    border-radius: 999px;
    background: #ecfdf5;
    color: #047857;
    font-size: 1.2rem;
    font-weight: 700;
    letter-spacing: .04em;
    text-transform: uppercase;
  }

  &__row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 24px;
  }

  &__inner {
    &--left {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 14px;

      h2 {
        margin: 0;
        font-size: clamp(2.8rem, 3vw, 4rem);
        line-height: 1.1;
        color: #111827;
      }

      p {
        margin: 0;
        color: #4b5563;
        line-height: 1.65;
        max-width: 60ch;
        font-size: 1.5rem;
      }

      &__hero-mobile {
        display: none;
      }

      &__scroll-down {
        margin-top: 8px;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        color: #047857;
        font-weight: 600;
        font-size: 1.4rem;

        img {
          width: 24px;
          height: 24px;
        }
      }
    }

    &--right {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        max-width: 540px;
        height: auto;
        border-radius: 14px;
      }
    }
  }
}

@media (max-width: 900px) {
  .biz-hero-container {
    grid-template-columns: 1fr;
    padding: 20px;

    &__inner {
      &--left {
        align-items: center;
        text-align: center;

        p {
          max-width: 100%;
        }

        &__hero-mobile {
          display: block;
          width: 100%;
          max-width: 560px;
          border-radius: 12px;
        }
      }

      &--right {
        display: none;
      }
    }
  }
}

.business-home-page {
  color: #1f2937;
}

.business-home-page .container {
  width: min(1200px, calc(100% - 32px));
  margin: 0 auto;
}

.business-home-page .section {
  position: relative;
  padding: 56px 0;
}

.business-home-page .section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 12px;
}

.business-home-page .section__head--center {
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.business-home-page .section__head h2 {
  margin: 0;
  font-size: clamp(2.6rem, 2vw, 3.4rem);
  line-height: 1.15;
  color: #111827;
}

.business-home-page .section__head p {
  margin: 0;
  color: #6b7280;
  max-width: 760px;
  font-size: 1.5rem;
  line-height: 1.55;
}

.business-home-page .section__illustration {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.business-home-page .section__illustration img {
  width: min(100%, 760px);
  height: auto;
  display: block;
}

.business-home-page .offer {
  padding-top: 28px;
}

.business-home-page .opinions {
  overflow: hidden;
}

.business-home-page .section-bg {
  position: absolute;
  inset: auto 0 0 0;
  pointer-events: none;
  opacity: .9;
  z-index: 0;
}

.business-home-page .section-bg img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  display: block;
}

.business-home-page .opinions .container {
  position: relative;
  z-index: 1;
}

.business-home-page .opinions__opinions-grid {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.business-home-page .contact-form__content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: start;
}

.business-home-page .contact-form__illustration img {
  width: 100%;
  height: auto;
  display: block;
}

.business-home-page .contact-form__card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
  padding: 24px;
}

.business-home-page .empty-state {
  margin: 16px 0 8px;
  min-height: 280px;
  border: 1px dashed #d1d5db;
  border-radius: 14px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;
  color: #6b7280;
  padding: 24px;
}

.business-home-page .empty-state__icon {
  width: 120px;
  height: 120px;
  border-radius: 999px;
  background: #ecfdf5;
  display: grid;
  place-items: center;
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.12);
}

.business-home-page .empty-state__icon img {
  width: 84px;
  height: 84px;
  display: block;
}

.business-home-page .empty-state h3 {
  margin: 4px 0 0;
  color: #374151;
  font-size: 2rem;
}

.business-home-page .empty-state p {
  margin: 0;
  max-width: 420px;
  font-size: 1.45rem;
}

@media (max-width: 1024px) {
  .business-home-page .opinions__opinions-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .business-home-page .contact-form__content {
    grid-template-columns: 1fr;
  }

  .business-home-page .contact-form__illustration {
    max-width: 680px;
    margin: 0 auto;
  }
}

@media (max-width: 720px) {
  .business-home-page .section {
    padding: 44px 0;
  }

  .business-home-page .opinions__opinions-grid {
    grid-template-columns: 1fr;
  }

  .business-home-page .contact-form__card {
    padding: 16px;
  }

  .business-home-page .section-bg img {
    height: 160px;
  }
}
</style>